/**
 *
 * useChangeSlot
 *
 */

import { useReducer } from 'react';
import produce from 'immer';
import { omit } from 'lodash-es';
import { addMinutes, subMinutes } from 'utils/date-fns/index.js';
import { SLOT_OPEN, SLOT_ACTIONS } from '../../constants.js';

function useChangeSlot(meetingSet, initialBlock) {
  const { duration, timeStep } = meetingSet;

  function makeNewSlot(start) {
    return {
      start,
      end: addMinutes(start, duration),
      blockId: initialBlock.id,
      status: SLOT_OPEN,
    };
  }
  function init() {
    const block = omit(initialBlock, ['slots', 'action']);
    if (!block.timeslots) {
      block.timeslots = initialBlock.slots
        .filter((start) => start < initialBlock.end)
        .map(makeNewSlot);
    }
    return block;
  }

  const reducer = produce((draft, action) => {
    const { idx, data, type } = action;
    switch (type) {
      case 'addSlot':
        if (idx === 0) {
          const newSlot = makeNewSlot(subMinutes(draft.start, timeStep));
          draft.start = newSlot.start;
          draft.timeslots.unshift(newSlot);
        } else {
          const newSlot = makeNewSlot(draft.end);
          draft.end = addMinutes(draft.end, timeStep);
          draft.timeslots.push(newSlot);
        }
        break;
      case 'removeSlot':
        if (idx === 0) {
          draft.start = addMinutes(draft.start, timeStep);
          draft.timeslots = draft.timeslots.slice(1);
        } else {
          draft.end = subMinutes(draft.end, timeStep);
          draft.timeslots = draft.timeslots.slice(0, -1);
        }
        break;
      case 'changeBlock': {
        const { start, end, slots } = data;
        draft.start = start;
        draft.end = end;
        draft.timeslots = slots.map(makeNewSlot);
        break;
      }
      case 'makeBreak':
      case 'makeMeeting':
        draft.timeslots[idx].status = SLOT_ACTIONS[type];
        break;
      default:
        throw new Error(`Invalid type: ${type}`);
    }
  });
  const [block, onSlotChange] = useReducer(reducer, undefined, init);
  return { block, onSlotChange };
}

export default useChangeSlot;
